
import { useState } from 'react';
import { categories, genres } from '../../mocks/content';

const SearchBar = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [selectedGenre, setSelectedGenre] = useState('Todos los géneros');
  const [showFilters, setShowFilters] = useState(false);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Buscando:', { searchTerm, selectedCategory, selectedGenre });
  };

  return (
    <div className="relative">
      <form onSubmit={handleSearch} className="flex items-center">
        <div
          className={`flex items-center bg-white/10 backdrop-blur-md rounded-full border border-white/20 transition-all duration-300 ${
            isExpanded ? 'w-80' : 'w-12'
          }`}
        >
          <button
            type="button"
            onClick={() => setIsExpanded(!isExpanded)}
            className="w-12 h-12 flex items-center justify-center text-white hover:text-pink-500 transition-colors cursor-pointer"
            aria-label="Search"
          >
            <i className="ri-search-line text-xl"></i>
          </button>

          {isExpanded && (
            <>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Buscar contenido..."
                className="flex-1 bg-transparent text-white placeholder-white/60 text-sm outline-none pr-4"
                autoFocus
              />
              <button
                type="button"
                onClick={() => setShowFilters(!showFilters)}
                className="w-10 h-10 flex items-center justify-center text-white hover:text-pink-500 transition-colors mr-1 cursor-pointer"
                aria-label="Filters"
              >
                <i className="ri-filter-3-line text-lg"></i>
              </button>
            </>
          )}
        </div>
      </form>

      {/* Filters Dropdown */}
      {isExpanded && showFilters && (
        <div className="absolute top-14 right-0 w-80 bg-black/95 backdrop-blur-xl rounded-2xl border border-white/20 p-4 shadow-2xl">
          <div className="space-y-4">
            {/* Category Filter */}
            <div>
              <label className="block text-white text-xs font-medium mb-2 uppercase tracking-wider">
                Tipo de Contenido
              </label>
              <div className="flex flex-wrap gap-2">
                {categories.map((category) => (
                  <button
                    key={category}
                    type="button"
                    onClick={() => setSelectedCategory(category)}
                    className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                      selectedCategory === category
                        ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white'
                        : 'bg-white/10 text-white/80 hover:bg-white/20'
                    }`}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>

            {/* Genre Filter */}
            <div>
              <label className="block text-white text-xs font-medium mb-2 uppercase tracking-wider">
                Género
              </label>
              <div className="flex flex-wrap gap-2">
                {genres.map((genre) => (
                  <button
                    key={genre}
                    type="button"
                    onClick={() => setSelectedGenre(genre)}
                    className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                      selectedGenre === genre
                        ? 'bg-gradient-to-r from-cyan-500 to-blue-500 text-white'
                        : 'bg-white/10 text-white/80 hover:bg-white/20'
                    }`}
                  >
                    {genre}
                  </button>
                ))}
              </div>
            </div>

            {/* Apply Button */}
            <button
              type="button"
              onClick={() => setShowFilters(false)}
              className="w-full py-2.5 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full font-medium text-sm hover:shadow-lg hover:shadow-pink-500/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Aplicar Filtros
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
